// DevtoolGuard.jsx
import { useEffect } from "react";
import disableDevtool from "disable-devtool";
import { showUnauthorizedPage } from "./common/Utils";

export default function DevtoolGuard() {
    useEffect(() => {
        disableDevtool({
            md5: "", // Bỏ qua kiểm tra md5 nếu cần (mặc định không cần)
            url: "https://www.google.com", // URL chuyển hướng nếu tắt devtool thất bại
            tkName: "PIMATH", // Tên query string để bypass nếu cần (ví dụ: ?ddtk=xxx)
            interval: 300, // Tần suất kiểm tra (ms)
            disableMenu: true, // Chặn chuột phải
            stopIntervalTime: 10000, // Thời gian dừng theo dõi trên mobile sau x ms
            clearIntervalWhenDevOpenTrigger: true, // Không ngừng theo dõi khi phát hiện mở DevTool
            detectors: "all", // Bật tất cả detector
            clearLog: true, // Xóa console log mỗi lần kiểm tra
            // disableSelect: true, // Chặn bôi đen
            // disableCopy: true, // Chặn copy
            // disableCut: true, // Chặn cut
            // disablePaste: true, // Chặn paste
            ignore: null, // Không bỏ qua trường hợp nào
            disableIframeParents: true, // Ngăn dùng khi trong iframe
            timeOutUrl: "https://www.google.com", // URL nếu trang timeout
            rewriteHTML: showUnauthorizedPage(), // HTML hiển thị nếu devtool bị phát hiện

            // Callback khi mở DevTools
            ondevtoolopen: (type, next) => {
                window.location.href = "https://www.google.com";
            },

            // Callback khi DevTools được đóng
            ondevtoolclose: () => {
                console.log("DevTools đã đóng");
            },
        });
    }, []);

    return null;
}
